import { render } from "./GMSerializationTab.vue?vue&type=template&id=32d84778&scoped=true"
import script from "./GMSerializationTab.vue?vue&type=script&lang=js"
export * from "./GMSerializationTab.vue?vue&type=script&lang=js"

import "./GMSerializationTab.vue?vue&type=style&index=0&id=32d84778&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d84778"],['__file',"src/views/Products/GMWorkFlow/GMSerializationTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32d84778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32d84778', __exports__)) {
    api.reload('32d84778', __exports__)
  }
  
  module.hot.accept("./GMSerializationTab.vue?vue&type=template&id=32d84778&scoped=true", () => {
    api.rerender('32d84778', render)
  })

}


export default __exports__